export function kmToMiles(km, precision = 2) {
  return parseFloat((km * 0.62137119).toFixed(precision));
}

export function milesToKm(miles, precision = 2) {
  return parseFloat((miles * 1.609344).toFixed(precision));
}

// US liquid gallon
const LITRES_PER_GALLON = 3.785411784;

export function litresToGallons(litres, precision = 2) {
  return parseFloat((litres / LITRES_PER_GALLON).toFixed(precision));
}

export function mtToFeet(mt, precision = 2) {
  return parseFloat((mt * 3.28084).toFixed(precision));
}
export function mtToMile(mt, precision = 2) {
  return parseFloat((mt * 0.00062137119).toFixed(precision));
}
export function mtToKm(mt, precision = 2) {
  return parseFloat((mt * 0.001).toFixed(precision));
}

export function feetToMt(feet, precision = 2) {
  return parseFloat((feet * 0.3048).toFixed(precision));
}

export function kgToPound(kg, precision = 2) {
  return parseFloat((kg * 2.20462).toFixed(precision));
}

export function poundToKg(pound, precision = 2) {
  return parseFloat((pound * 0.453592).toFixed(precision));
}

export function convertKm(km, unit) {
  return unit === 'METRIC' ? km : kmToMiles(km);
}

/**
 * Format a walking distance (stored in meters) based on length unit.
 * @param {number|null|undefined} meters - Distance in meters from API
 * @param {string} unit - Length unit ('METRIC' or 'IMPERIAL')
 * @param {number} [precision=1] - Decimal places
 * @returns {string} Formatted distance with unit (e.g. "120.5 m" or "395.3 ft")
 */
export function formatWalkingDistance(meters, unit = 'METRIC', precision = 1) {
  if (meters === null || meters === undefined) return '-';
  const value = Number(meters);
  if (Number.isNaN(value)) return '-';
  if (value === 0) return `0 ${unit === 'IMPERIAL' ? 'ft' : 'm'}`;
  return unit === 'IMPERIAL' ? `${mtToFeet(value, precision)} ft` : `${value.toFixed(precision)} m`;
}

export function convertTo12Hour(time) {
  if (!time) return '';

  // Handle time string format
  const timeParts = time.split(':');
  const hours = parseInt(timeParts[0], 10);
  const minutes = timeParts[1] || '00';

  // Validate that we have valid hours and minutes
  if (Number.isNaN(hours) || !minutes) return time;

  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes} ${ampm}`;
}

export function convertMinutesToHoursAndMinutes(minutes, object = false) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (object) return { hours, minutes: remainingMinutes };
  return `${hours ? `${hours}h` : ''} ${remainingMinutes ? `${remainingMinutes}m` : ''}`.trim();
}

export function convertToHoursAndMinutes(time) {
  const hours = Math.floor(time / 60);
  const minutes = Math.floor(time % 60);

  const hoursText = hours > 0 ? `${hours} hr` : '';
  const minutesText = minutes > 0 ? `${minutes} min` : '';

  return `${hoursText} ${minutesText}`.trim();
}
// converts hour and minutes in string format (e.g. 22:30) to Date object
export function convertTimeStringToDate(time) {
  const [hours, minutes] = time.split(':');
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  return date;
}

// converts integer dates to minutes
// 30 -> 30 minutes
// 2330 -> 23 hours 30 minutes
export function convertIntHourFormatToMinutes(time) {
  const hours = Math.floor(time / 100);
  const minutes = time % 100;
  return hours * 60 + minutes;
}
